<template>
    <div class="main-container">
        <div>
            <div class="d-flex justify-content" style="padding: 10px;">
                <div class="ml-10 mr-10 d-flex align-items-center">
                    <p class="mr-5" style="width: 100px;font-pageSize: 14px">角色名称:</p>
                    <el-input placeholder="请输入角色名称" prefix-icon="el-icon-search" v-model="searchForm.name">
                    </el-input>
                </div>

                <div class="ml-10 mr-10 d-flex align-items-center">
                    <p class="mr-5" style="width: 100px;font-pageSize: 14px">角色类型:</p>
                    <el-select v-model="searchForm.roleType" placeholder="请选择角色类型">
                        <el-option label="内置角色" :value="0"></el-option>
                        <el-option label="自定义角色" :value="1"></el-option>
                    </el-select>
                </div>

                <el-button type="primary" @click="getUserList" pageSize="small">查询</el-button>
                <el-button @click="handleReset" pageSize="small">重置</el-button>
            </div>
            <div class="d-flex justify-content-left" style="padding: 10px 0;">
                <el-button type="primary" style="width: 100px;" @click="addUser" v-if="pagePermission.includes('add')">添加</el-button>
            </div>

            <el-table stripe pageSize="small " :data="userList" style="width: 100%" border>
                <el-table-column type="index" label="序号" width="60" align="center">
                </el-table-column>
                <el-table-column prop="name" label="角色名称" width="200"></el-table-column>
                <el-table-column prop="roleType" label="角色类型" width="200">
                    <template slot-scope="{ row }">
                        <el-tag v-if="row.roleType === 0">内置角色</el-tag>
                        <el-tag type="success" v-else>自定义角色</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="roleDesc" label="角色描述"></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" width="240" align="center">
                    <template slot-scope="scope">
                        <el-button pageSize="mini" type="text" @click="handleModify(scope.$index, scope.row)" v-if="pagePermission.includes('sysRole')">编辑</el-button>
                        <el-button pageSize="mini" type="text" @click="handleSetMenuRight(scope.$index, scope.row)" v-if="pagePermission.includes('permission')">权限设置</el-button>
                        <el-button pageSize="mini" style="color:red" type="text" @click="handleDelete(scope.$index, scope.row)" v-if="pagePermission.includes('delete')">删除</el-button>
                        <el-button pageSize="mini" type="text" @click="handleAuth(scope.$index, scope.row)" v-if="pagePermission.includes('auth')">授权</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-pagination class="mb-15" background @current-change="handleCurrentChange" @prev-click="prevPage" @next-click="nextPage" layout="prev, pager, next" :total="pageNum">
        </el-pagination>

        <!-- 弹出框 -->
        <el-dialog :title="title" :visible.sync="dialogVisible" width="570px">
            <div class="content">
                <div class="d-flex align-items-center mb-15">
                    <p class="w-100 text-left">角色名称:</p>
                    <el-input style="width: 350px;" placeholder="请输入角色名称" v-model="form.name" :disabled="userValue == 'check'" clearable>
                    </el-input>
                </div>

                <div class="d-flex align-items-center mb-15">
                    <p class="w-100 text-left">角色类型:</p>
                    <el-radio-group v-model="form.roleType">
                        <el-radio :label="0" v-if="pagePermission.includes('sysRole')">内置角色</el-radio>
                        <el-radio :label="1">自定义角色</el-radio>
                    </el-radio-group>
                </div>
                <div class="d-flex align-items-center mb-15">
                    <p class="w-100 text-left">角色描述:</p>
                    <el-input type="textarea" style="width: 350px;" placeholder="请输入角色描述" v-model="form.roleDesc" :disabled="userValue == 'check'" clearable>
                    </el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirm" v-if="userValue != 'check'">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 权限设置 -->
        <el-dialog title="权限设置" :visible.sync="isShow" width="570px">
            <el-tabs v-model="activeName" @tab-click="handleClickTab">
                <el-tab-pane label="PC端" name="0"></el-tab-pane>
                <el-tab-pane label="小程序" name="1"></el-tab-pane>
            </el-tabs>
            <div class="tree-container">
                <el-tree :data="menuList" show-checkbox node-key="id" ref="tree" highlight-current :check-strictly="checkStrictly" :props="defaultProps">
                </el-tree>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-checkbox v-model="checkAll" @change="handleCheckAll" style="float: left">全选</el-checkbox>
                <el-button @click="isShow = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit">确 定</el-button>
            </span>
        </el-dialog>
         <AuthRoleComponent :isBind="isBind" :httpConfig="httpConfig" :propsData="propsData"  @close="isBind = false"/>
    </div>
</template>

<script>
import { get, post, deleteRequest, putRequest } from "../../../utils/request";
import { cloneDeep } from "lodash";
import AuthRoleComponent from '@/components/authRoleComponent/index'
export default {
    name: "roleManage",
    computed: {
        pagePermission() {
            return this.$store.state.pagePermission || [];
        },
    },
    components: {
        AuthRoleComponent
    },
    data() {
        return {
            httpConfig: {
                getHotel: "/role/roleAuthList",//get获取已绑定的酒店列表
                selectHotel: "/role/listForPage",//get获取要绑定的酒店列表
                bindHotel: "/role/bindRoleAuth",//postRequest绑定
                unbindHotel:"/role/unBindRole"
            },
            searchForm: {
                name: "",
                roleType: '',
                pageNumber: 1,
                pageSize: 10
            },
            propsData: {
                roleId: '',
                name: '',
            },
            isBind: false,
            title: '',
            userValue: '',
            dialogVisible: false,
            userList: [],
            pageNum: 0,
            form: {
                name: "",
                roleDesc: "",
                roleType: 1,
            },

            menuList: [],
            isShow: false,
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            checkAll: false,
            checkStrictly: false,
            roleId: "",
            activeName: 0
        }
    },
    methods: {
        handleSubmit() {//提交选择的权限
            let selectNodes = this.$refs.tree.getCheckedKeys();
            putRequest(`/role/distributeRole`, {
                roleId: this.roleId,
                menuIds: selectNodes,
                type: this.activeName
            })
                .then(res => {
                    let data = res.data;
                    if (data.code == 200) {
                        this.isShow = false;
                        // console.log(data.data);
                        this.$message.success(data.msg);
                    }

                })
        },
        handleAuth(index, row) {
            this.propsData.roleId = row.id;
            this.propsData.name = row.name
            this.$nextTick(() => {
                this.isBind = true
            })
        },
        handleCheckAll(val) {
            this.checkStrictly = false;
            if (val) {
                this.$nextTick(() => {
                    this.$refs.tree.setCheckedNodes(this.menuList);
                    this.checkStrictly = true;
                })

            } else {
                this.$refs.tree.setCheckedNodes([]);
                this.checkStrictly = true;

            }
        },
        handleClickTab(e) {
            this.activeName = e.name;
            this.getAllMenuList();
            this.getCheckMenuList();
        },
        handleSetMenuRight(index, row) {
            this.roleId = row.id;

            this.activeName = "0";
            this.getAllMenuList(1);


        },
        getCheckMenuList(key) {
            this.checkAll = false;
            this.checkStrictly = true;
            get(`/role/getRoleMenu`, {
                roleId: this.roleId,
                type: this.activeName
            }).then(res => {
                let data = res.data;
                if (data.code == 200) {
                    // if(key) {
                    this.isShow = true;
                    // }
                    this.$nextTick(() => {
                        this.$refs.tree.setCheckedNodes(data.data);
                        // this.checkStrictly = true;
                    })
                }
            })
                .catch(err => {
                    console.log(err);
                })
        },
        handleReset() {
            this.searchForm = {
                ame: "",
                roleType: '',
                pageNumber: 1,
                pageSize: 10
            }
            this.getUserList();
        },
        //获取用户列表
        getUserList() {
            this.searchForm.pageNumber = 1;
            //获取用户列表
            this.userListRequest();
        },

        //获取用户列表请求
        userListRequest() {
            get('/role/listForPage', this.searchForm)
                .then(res => {
                    // console.log(res);
                    this.userList = res.data.data.records
                    this.pageNum = res.data.data.total
                })
                .catch(err => {
                    console.log(err);
                })
        },

        //删除用户方法
        handleDelete(index, row) {
            deleteRequest('/role/delByIds/' + row.id)
                .then(res => {
                    console.log(res);
                    let data = res.data;
                    if (data.code == 200) {
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 1000
                        });
                        setTimeout(() => {
                            this.getUserList();
                        }, 1000)
                    }

                })
                .catch(err => {
                    console.log(err);
                })
        },

        //增加用户方法
        addUser() {
            this.form = {
                roleType: 1
            }
            this.dialogVisible = true
            this.title = '添加角色'
            this.userValue = 'addRole'
            this.getUserList()
        },

        handleCheck(index, row) {
            this.userValue = 'check'
            this.dialogVisible = true
            this.title = '查看角色信息'
            this.form = row
        },

        //修改用户信息
        handleModify(index, row) {
            this.form = cloneDeep(row);
            this.dialogVisible = true
            this.title = '编辑角色'
            this.userValue = 'editRole'
        },

        //
        confirm() {
            let value = this.userValue;
            if (value == 'addRole') {
                post('/role/addRole', this.form)
                    .then(res => {
                        // console.log(res);
                        if (res.data.code === "200") {
                            this.$message({
                                message: '操作成功！',
                                type: 'success',
                                duration: 1000
                            });
                            this.getUserList();
                            this.dialogVisible = false;
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type: 'warning',
                                duration: 1000
                            });

                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
            } else if (value == 'editRole') {
                putRequest('/role/editRole', this.form)
                    .then(res => {
                        // console.log(res);
                        if (res.data.code === "200") {
                            this.$message({
                                message: '操作成功！',
                                type: 'success',
                                duration: 1000
                            });
                            this.getUserList();
                            this.dialogVisible = false;
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type: 'warning',
                                duration: 1000
                            });

                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
            }
        },

        //选择页码
        handleCurrentChange(num) {
            this.searchForm.pageNumber = num;
            this.userListRequest()
        },

        //上一页
        prevPage(num) {
            this.searchForm.pageNumber = num;
            this.userListRequest()

        },

        //下一页
        nextPage(num) {
            this.searchForm.pageNumber = num;
            this.userListRequest()
        },
        getAllMenuList(key) {
            post('/api/menu/getCurrTree', {
                type: this.activeName
            })
                .then(res => {
                    let data = res.data;
                    if (data.code == 200) {
                        this.menuList = data.data;
                        this.getCheckMenuList();
                    }

                })
                .catch(err => {
                    console.log(err);
                })
        }

    },
    mounted() {

        this.getUserList();
    },

}
</script>

<style type="less" scoped>
@import url("./index.less");
</style>
